import React, { useState } from 'react'

import styled from 'styled-components'
import Modal from 'components/lib/Modal'
import Grid from 'components/lib/Grid'
import Button from 'components/lib/Button'

import withRedux from 'components/redux'
import * as common from 'utils/UtilityStore/actions'
import { request } from 'core/constants'
const Subtitle = styled.p`
  font-weight: bold;
  width: 100%;
  color: #5f6775;
`

const Divider = styled.hr`
  width: 100%;
  border: 0;
  opacity: 0.5;
  margin-top: 10px;
  margin-bottom: 10px;
`

const Description = styled.p`
  color: #6b6f77;
`

const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  & > span {
    color: #ef4444;
  }
`

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
`

const LoadingContainer = styled.div`
  height: 250px;
  margin-top: 100px;
`

const Spinner = styled.div`
  margin: 0 auto;
  padding: 45px 60px;
`

const ResendExtraBillingModal = ({
  isOpen,
  onClose,
  onResent,
  extraBilling,
  companyId,
  proposalId,
  notification,
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const submit = async () => {
    try {
      setIsLoading(true)

      await request.post(
        `/company/${companyId}/proposal/${proposalId}/extra-billing/${extraBilling.id}/resend-email`,
      )

      notification({
        message: 'Cobrança adicional reenviada com sucesso!',
      })

      setIsLoading(false)

      onResent()
    } catch (err) {
      setIsLoading(false)

      notification({
        message: err?.message ? err.message : 'Erro ao reenviar cobrança adicional',
        status: err ? 'warning' : 'danger',
      })
    }
  }

  if(!extraBilling) return null

  if (isLoading) {
    return (
      <Modal title='Reenvio de cobrança' isOpen={isOpen} onClose={onClose}>
        <div>
          <LoadingContainer>
            <Spinner className='empty-state-spinner' />
          </LoadingContainer>
        </div>
      </Modal>
    )
  }

  return (
    <Modal title='Reenvio de cobrança' isOpen={isOpen} onClose={close}>
      <Subtitle>
        DADOS DO PRETENDENTE
        <Divider />
      </Subtitle>
      <Grid>
        <Grid.Col>
          <Label>Email</Label>
          <Description>{extraBilling.billing_email}</Description>
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col>
          <Label>Valor</Label>
          <Description>
            {`R$ ${extraBilling.price.toFixed(2).replace('.', ',')}`}
          </Description>
        </Grid.Col>
      </Grid>

      <ButtonGroup>
        <Button isBare onClick={onClose}>
          Cancelar
        </Button>
        <Button hasThemeColor isLoading={false} onClick={submit}>
          Reenviar
        </Button>
      </ButtonGroup>
    </Modal>
  )
}

export default withRedux(
  (store) => ({
    user: store.app.activeUser,
  }),
  { ...common },
)(ResendExtraBillingModal)
